import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BlockedAccountBannerProps {
  isBlocked: boolean;
}

export function BlockedAccountBanner({ isBlocked }: BlockedAccountBannerProps) {
  const { t } = useTranslation();

  if (!isBlocked) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <p className="text-sm font-medium text-center">
          {t('common:blocked_account_banner')}
        </p>
      </div>
    </div>
  );
}
